import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    // Event list
    event_list: '/dashboard/v1/pica-services/',

    // Event creation
    setup: '/dashboard/v2/events/setup/', // POST
    create_config: '/dashboard/v2/events/create_config/', // GET
    categories: '/dashboard/v2/events/regions/{region}/categories/', // GET
    contracts: '/dashboard/v2/events/contracts/', // GET
    contract: '/dashboard/v2/events/contracts/{id}/', // GET
}

// Mapping frontend column keys to backend ordering fields
const orderingFieldsMap = {
    id: 'id',
    name: 'event__name',
    event_start_at: 'event__start_at',
    status: 'event__is_draft',
    is_promo: 'is_promo',
    is_saas: 'contract_manager__is_saas',
    contract: 'contract__name',
    contract_manager: 'contract_manager__name',
}

// Mapping frontend filter keys to backend filter params
const filterFieldsMap = {
    name: 'event_name',
    status: 'event__is_draft',
    // is_saas viene passato direttamente come 'is_saas'
}

export default {
    async fetchEventList(filters, pagination, sorting, contractId = null) {
        const orderingColumn = sorting.column ? orderingFieldsMap[sorting.column] : null
        const ordering = orderingColumn
            ? (sorting.asc ? `-${orderingColumn}` : orderingColumn)
            : ''

        // Map frontend filter keys to backend params
        const mappedFilters = {}
        for (const [key, value] of Object.entries(filters)) {
            if (value === '' || value === null || value === undefined) continue
            const backendKey = filterFieldsMap[key] || key
            mappedFilters[backendKey] = value
        }

        const result = await client.get(endpoints.event_list, {
            ...mappedFilters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering,
            contract_id: contractId,
        })

        // Flatten nested fields per CDataTable sorting (richiede che le chiavi esistano nell'item)
        const flattenedResults = result.results.map(item => ({
            ...item,
            name: item.event?.name,
            event_start_at: item.event?.start_at,
            status: item.event?.is_draft,
        }))

        return {
            results: flattenedResults,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },

    async createNewEvent(data) {
        return await client.post(endpoints.setup, data)
    },
    async fetchCreateConfig({region, plan, category}, contractId = null) {
        let params = {}
        if (region && region.length > 0) params.region = region
        if (plan && plan.length > 0) params.plan = plan
        if (category && category.length > 0) params.category = category
        if (contractId) params.contract_id = contractId
        return await client.get(endpoints.create_config, params)
    },
    async fetchCategories(region) {
        return await client.get(endpoints.categories.replace('{region}', region))
    },
    async fetchContracts() {
        return await client.get(endpoints.contracts)
    },
    async fetchContract(id) {
        return await client.get(endpoints.contract.replace('{id}', id))
    }
}

